import { useSyncExternalStore } from 'react';
import { SessionController, type AppState } from './controller';

export const controller = new SessionController();

// Em desenvolvimento, expõe o controlador para scripts de teste via DevTools/CDP.
if (import.meta.env.DEV) {
  (window as Window & { __viewer?: SessionController }).__viewer = controller;
}

export function useAppState(): AppState {
  return useSyncExternalStore(controller.subscribe, controller.getSnapshot);
}
